import { atom } from 'recoil';
import { TEMPLATE_LOADOUT } from '../utils/constantsCollection';

export const loadoutAtom = {
	id: atom({ key: 'loadoutIdAtom', default: -1 }),
	edit: atom({ key: 'loadoutEditAtom', default: false }),
	name: atom({ key: 'loadoutNameAtom', default: 'Empty' }),
	ignoreTools: atom({ key: 'loadoutIgnoreToolsAtom', default: false }),
	unequipEmptySlots: atom({ key: 'loadoutUnequipEmptySlotsAtom', default: false }),
	equipment: atom({
		key: 'loadoutEquipmentAtom',
		default: { changed: false, equipment: structuredClone(TEMPLATE_LOADOUT.equipment) },
	}),
	abilty: atom({
		key: 'loadoutAbilityAtom',
		default: { changed: false, abilities: structuredClone(TEMPLATE_LOADOUT.abilityRotation) },
	}),
	food: atom({
		key: 'loadoutFoodAtom',
		default: { changed: false, food: structuredClone(TEMPLATE_LOADOUT.foodInventory) },
	}),
};
